import { axios } from "../../config/axiosConfig";
import { endpoints } from "../../config/apiConfig";

async function getTemplatePaginatedData(data) {
  return axios
    .post(endpoints.emailTemp.getEmailTempPaginatedData, data)
    .then(data => {
      return data;
    })
    .catch(error => {
      return null;
    });
}

async function addUpdateTemple(data) {
  return axios
    .post(endpoints.emailTemp.addUpdateTemplate, data)
    .then(data => {
      return data;
    })
    .catch(error => {
      return null;
    });
}

async function getTemplateById(id) {
  try {
    const response = await axios.get(
      `${endpoints.emailTemp.getTemplateById}${id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching lead generation data:", error);
    return null;
  }
}

async function deleteTemplate(id) {
  return axios
    .post(`${endpoints.emailTemp.deleteTemplate}${id}`)
    .then(data => {
      return data;
    })
    .catch(error => {
      return null;
    });
}

export const emailTemplateApi = {
  getTemplatePaginatedData: getTemplatePaginatedData,
  addUpdateTemple: addUpdateTemple,
  getTemplateById: getTemplateById,
  deleteTemplate: deleteTemplate,
};
